var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ApolloLink } from '@apollo/client';
import { errorsRow, fragmentRow, messageRow, operationRow, variablesRow, } from './rows/index.js';
var prepareSubrows = function (operation, options) {
    var result = {
        isSingleRow: true,
        subrows: [],
    };
    var _a = options.style, style = _a === void 0 ? 'css' : _a;
    var rows = [fragmentRow, variablesRow, messageRow];
    rows.forEach(function (handler) {
        var row = handler(operation, style);
        if (row.length) {
            result.isSingleRow = false;
            result.subrows.push(row);
        }
    });
    return result;
};
var printer = function (operation, options, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
errors, isOK) {
    if (errors === void 0) { errors = []; }
    var _a = options.style, style = _a === void 0 ? 'css' : _a;
    var mainrow = operationRow(operation, style, isOK, errors);
    var _b = prepareSubrows(operation, options), isSingleRow = _b.isSingleRow, subrows = _b.subrows;
    try {
        if (isSingleRow) {
            console.log.apply(console, mainrow);
        }
        else {
            var _c = options.collapsed, collapsed = _c === void 0 ? false : _c;
            var group = collapsed ? 'groupCollapsed' : 'group';
            console[group].apply(console, mainrow);
            errors.forEach(function (error) {
                var subrow = errorsRow(error, style);
                console.log.apply(console, subrow);
            });
            subrows.forEach(function (subrow) {
                console.log.apply(console, subrow);
            });
            console.groupEnd();
        }
    }
    catch (err) {
        console.error(err);
    }
};
function operationPrinter(options) {
    return new ApolloLink((function (operation, forward) {
        return forward(operation).map(function (response) {
            try {
                var _a = options.print, print_1 = _a === void 0 ? true : _a, otherOptions = __rest(options, ["print"]);
                if (print_1) {
                    var _b = response.errors, errors = _b === void 0 ? [] : _b;
                    var isOK = 'data' in response;
                    printer(operation, otherOptions, errors, isOK);
                }
            }
            catch (errMsg) {
                console.error(errMsg);
            }
            return response;
        });
    }));
}
/**
 * @description Pretty logger of Apollo GraphQL network operations
 * @doc https://github.com/egorlem/apollo-link-printer
 */
var PrinterLink = /** @class */ (function (_super) {
    __extends(PrinterLink, _super);
    function PrinterLink(option) {
        if (option === void 0) { option = {}; }
        var _this = _super.call(this) || this;
        _this.link = operationPrinter(option);
        return _this;
    }
    PrinterLink.prototype.request = function (operation, forward) {
        return this.link.request(operation, forward);
    };
    return PrinterLink;
}(ApolloLink));
export { PrinterLink };
//# sourceMappingURL=printerLink.js.map